// extracted by mini-css-extract-plugin
export default {"history":"history_history__ifmDi","content":"history_content__++lHg","history_card":"history_history_card__KShxs"};